module.exports = __webpack_public_path__ + "4dcbcffe9b0cc1a0169343d81f03a3eb.svg";